import React from 'react'

const FooterComponents = () => {
  return (
    <div className='footer'>
      <div className='container'> 
        <div className='row justify-content-center'>
          <div className='col-auto'>
              <p>Reaturant &#169; Copyright 2024</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FooterComponents